import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Modal, Button } from 'react-bootstrap';

function getCroppedImg(imageSrc, cropPixels) {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = imageSrc;
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = cropPixels.width;
      canvas.height = cropPixels.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        cropPixels.x, cropPixels.y, cropPixels.width, cropPixels.height,
        0, 0, cropPixels.width, cropPixels.height
      );

      canvas.toBlob((blob) => {
        blob.name = 'cropped.jpeg';
        resolve(blob);
      }, 'image/jpeg', 0.9);
    };
  });
}

function ImageCropModal({ show, imageSrc, onCancel, onCropComplete }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleConfirm = async () => {
    const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCropComplete(croppedBlob);
  };

  return (
    <Modal show={show} onHide={onCancel} centered size="lg">
      <Modal.Header closeButton
      
       style={{
          background: '#141414', 
        }}>

 
        <Modal.Title>
          <h5 >
            Adjust Image
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ position: 'relative', height: '400px', background: '#141414' }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1} // 1 = square crop, use 16/9 etc for other ratios
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
        />
      </Modal.Body>
      <Modal.Footer style={{ flexDirection: 'column', gap: '10px', background: '#141414'  }}>
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          style={{ width: '100%' }}
        />
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', width: '100%' }}>
          <Button variant="secondary" onClick={onCancel}
           className="process-card-text hover-brighten-red"
                              style={{
                                padding: '10px 20px',
                                // marginTop: '10px',
                                backgroundColor: 'red',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                  0 12px 24px rgba(0, 0, 0, 0.6),
                                  0 32px 64px rgba(0, 0, 0, 0.5),
                                  0 64px 100px rgba(0, 0, 0, 0.35)
                                `,
                                borderRadius: '999px',
                                cursor: 'pointer',
                                textAlign: 'center',
                              }}
          >
            <h5 style={{ margin: '1%' }}>Cancel</h5>
            </Button>
          <Button variant="success" onClick={handleConfirm}
           className="process-card-text hover-brighten-green"
                              style={{
                                padding: '10px 20px',
                                // marginTop: '10px',
                                backgroundColor: 'green',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                  0 12px 24px rgba(0, 0, 0, 0.6),
                                  0 32px 64px rgba(0, 0, 0, 0.5),
                                  0 64px 100px rgba(0, 0, 0, 0.35)
                                `,
                                borderRadius: '999px',
                                cursor: 'pointer',
                                textAlign: 'center',
                              }}
          >
            <h5 style={{ margin: '1%' }}>Save</h5>
            </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ImageCropModal;